import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "copyright",
    style: _normalizeStyle([_ctx.text ? { display: 'flex' } : { display: 'none' }])
  }, [
    _withDirectives(_createElementVNode("hr", null, null, 512), [
      [_vShow, this.description]
    ]),
    _createElementVNode("h6", null, _toDisplayString(_ctx.label), 1)
  ], 4))
}